export default {"src":"/_next/static/media/RP.0d604bb8.svg","height":14,"width":18};